import React, { useState, useEffect } from 'react'
import { Box, Button, Divider, TextField, Modal, Grid } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material'
import DialogTitle from '@mui/material/DialogTitle'
import { useStyles } from './SettingsStyles'
import { EditHolidayDataSettings, getHolidayData } from '../../actions/api/fetchCalendarData'
import { DialogContentText } from '@mui/material'
import DatePicker from '@mui/lab/DatePicker'
import moment from 'moment-timezone'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import SuccessSnackBar from '../HOC/SuccesSnackBar'
import ErrorSnackBar from '../HOC/ErrorSnackBar'
import { RootState } from 'reducers'

export default function EditHolidayDialog({ open, handleClose, params }) {
  const dispatch = useDispatch()
  const classes = useStyles()
  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)

  const [holidayDate, setHolidayDate] = useState('')
  const [holidayName, setHolidayName] = useState('')

  const [holidayDateChanged, setholidayDateChanged] = useState(false)
  const [holidayNameChanged, setholidayNameChanged] = useState(false)

  const [selectedDate, setSelectedDate] = useState(moment(params.holiday_date).format('MM-DD-YYYY')?.toString())

  const [displayDuplicateDateError, setDisplayDuplicateDateError] = useState(false)
  const holidayData = useSelector((state: RootState) => state.addHolidayData)

  const holidayDateList = holidayData.data.map((element) => element.holiday_date)

  const [openDialog, setOpenDialog] = React.useState(false)
  const [disableSubmit, setDisableSubmit] = useState(true)
  const getClassNames = () => (disableSubmit || displayDuplicateDateError ? `${classes.disableBtn} ` : `${classes.btn}`)
  const { add_holiday_success, add_holiday_error } = useSelector((state: RootState) => state.addHolidayResponse)
  const { edit_holiday_success, edit_holiday_error } = useSelector((state: RootState) => state.editHolidayResponse)

  const handleCloseDialog = (type) => {
    if (type === 'confirm') {
      setHolidayDate(params.holiday_date ? moment(params.holiday_date).format('MM/DD/YYYY')?.toString() : '')
      setholidayDateChanged(false)
      setholidayNameChanged(false)
      setDisplayDuplicateDateError(false)
      setDisableSubmit(true)
    }
    setOpenDialog(false)
  }
  useEffect(() => {
    setHolidayDate(params.holiday_date ? moment(params.holiday_date).format('MM/DD/YYYY')?.toString() : '')
    setHolidayName(params.holiday_name)
  }, [params.holiday_date, params.holiday_name])

  const onCancel = (e) => {
    if (holidayDateChanged || holidayNameChanged) {
      setOpenDialog(true)
    } else {
      handleClose()
      setHolidayName('')
      setDisableSubmit(true)
    }
  }
  const onChangeData = (e) => {
    if (e.target.value === '') {
      setDisableSubmit(true)
    } else {
      setDisableSubmit(false)
      setHolidayName(e.target.value)
      setholidayNameChanged(true)
    }
  }
  const handleSubmit = async () => {
    const EditParameters = {
      id: params.id,
      holiday_date: holidayDate,
      holiday_name: holidayName.replaceAll("'", "''"),
    }
    await dispatch(EditHolidayDataSettings({ payload: EditParameters }))
    await setOpenSuccessSnackBar(true)
    await updateDataTable()
  }
  useEffect(() => {
    if (holidayNameChanged || holidayDateChanged) {
      setDisableSubmit(false)
    }
  }, [holidayDate, holidayName])
  const updateDataTable = () => {
    setHolidayDate('')
    setHolidayName('')
    dispatch(getHolidayData())
    setTimeout(closeModal, 100)
    setTimeout(() => setOpenSuccessSnackBar(false), 4000)
  }

  const handleDateChange = (date) => {
    if (!date) {
      setDisableSubmit(true)
      setDisplayDuplicateDateError(false)
    } else {
      const compareDate = moment(date).format('YYYY-MM-DD')?.toString()
      if (selectedDate === compareDate) {
        setDisplayDuplicateDateError(false)
        setHolidayDate(date)
        return
      }
      setDisplayDuplicateDateError(holidayDateList.includes(compareDate))
      setHolidayDate(date)
      setholidayDateChanged(true)
      setDisableSubmit(false)
    }
  }
  const closeModal = handleClose
  const SuccessMessage = `Edit Holiday operation successful`
  const ErrorMessage = `Edit Holiday operation failed`
  return (
    <React.Fragment>
      <div>
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          classes={{ paper: classes.discardDialogHeight }}
        >
          <DialogTitle className={classes.dialogTitle}>Discard Changes</DialogTitle>
          <DialogContent className={classes.discardDialogContent}>
            <DialogContentText id="alert-dialog-description">
              You have pending unsaved changes. Do you really want to discard them?
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.buttonActions}>
            <Button
              className={`${classes.btn} ${classes.buttonMargin}`}
              onClick={function (event) {
                handleCloseDialog('confirm')
                handleClose()
              }}
              autoFocus
              endIcon={<CheckIcon />}
            >
              Confirm
            </Button>
            <Button
              className={`${classes.buttonMargin}`}
              onClick={function (event) {
                handleCloseDialog('cancel')
              }}
              variant="outlined"
              endIcon={<ClearIcon />}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <div>
        {add_holiday_success && openSuccessSnackBar && <SuccessSnackBar message={SuccessMessage} />}
        {add_holiday_error && openSuccessSnackBar && <ErrorSnackBar message={ErrorMessage} />}
        {edit_holiday_success && openSuccessSnackBar && <SuccessSnackBar message={SuccessMessage} />}
        {edit_holiday_error && openSuccessSnackBar && <ErrorSnackBar message={ErrorMessage} />}
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className={`${classes.mt} , ${classes.mb}`}>
            <Dialog
              fullWidth
              maxWidth="sm"
              id="hello"
              classes={{ paper: classes.dialogHeight }}
              open={open}
              onClose={handleClose}
            >
              <DialogTitle className={classes.dialogTitle}>Edit Holiday</DialogTitle>
              <Divider />
              <DialogContent>
                <Box component="form" autoComplete="off">
                  <div className={classes.TextField}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        value={holidayDate}
                        label="Holiday Date*"
                        className={classes.HolidayDate}
                        onChange={(newValue) => handleDateChange(moment(newValue).format('MM/DD/YYYY')?.toString())}
                        InputProps={{
                          style: {
                            height: 45,
                            width: '50ch',
                          },
                        }}
                        renderInput={(params) => (
                          <TextField
                            autoFocus
                            label="Holiday Date"
                            variant="outlined"
                            inputProps={{
                              style: {
                                padding: 10,
                              },
                            }}
                            InputLabelProps={{ shrink: true }}
                            {...params}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </div>
                  {displayDuplicateDateError && (
                    <p className={classes.error}>
                      Selected date is already in the holiday list. Please select a different date.
                    </p>
                  )}
                  <div className={classes.TextField}>
                    <TextField
                      className={classes.TextBox}
                      label="Holiday Name*"
                      variant="outlined"
                      inputProps={{
                        style: {
                          padding: 10,
                        },
                        min: 1,
                      }}
                      onChange={(event) => onChangeData(event)}
                      defaultValue={params.holiday_name}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                </Box>
              </DialogContent>
              <DialogActions className={classes.buttonActions}>
                <Button onClick={handleSubmit} className={getClassNames()} endIcon={<CheckIcon />}>
                  Submit
                </Button>
                <Button
                  onClick={onCancel}
                  color="primary"
                  variant="outlined"
                  style={{ width: '115px' }}
                  endIcon={<ClearIcon />}
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </Modal>
      </div>
    </React.Fragment>
  )
}
